<template>
    <div class="content-container">
        <div class="content">
            <div class="container">
                <div class="row">

                    <!-- Title -->
                    <div class="col-12">
                        <div class="title">
                            <h1>What is your store code?</h1>
                        </div>
                    </div>

                    <!-- Search -->
                    <div class="col-12">
                        <div class="form-group">
                            <label v-if="!store && !error">Store code <span class="text-danger">*</span></label>
                            <label v-if="store && !error">Your store is being tracked. You can continue with the booking.</label>
                            <label v-if="error" class="text-danger">{{ error }}</label>
                            <div class="loading-input-container">
                                <div class="loading-message" v-if="searching">We're just checking that store code</div>
                                <input
                                        class="form-control postcode-search"
                                        :class="{'is-loading': searching, 'is-valid': store && !error, 'is-invalid': error}"
                                        :disabled="searching"
                                        placeholder="Enter your store code"
                                        type="text"
                                        v-model="storeCode"
                                        v-on:keyup="storeCodeWatcher"
                                />
                            </div>
    <!--                        <small @click="initiateSetIgnoreStore()" class="cursor-pointer form-text text-underline">Not in a store?</small>-->
                        </div>
                    </div>



                    <!-- Footer -->
                    <footer class="footer fixed-footer">
                        <div class="container">
                            <button class="btn btn-primary btn-lg continue-btn icon-right ml-auto" @click="checkStoreCode" :class="{'disabled': searching || !storeCode}">Check <span class="d-none d-sm-inline">store code</span> <i class="fa fa-chevron-right ml-3 text-sm"></i></button>
                        </div>
                    </footer>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: 'StoreSearch',

        data() {
            return {
                error: null,
                storeCode: null,
                searching: false
            }
        },

        mounted() {
            if(false === this.allowsInStoreBooking) {
                this.$router.push({name: 'postcodeSearch'});
            }

            if (this.store) {
                this.storeCode = this.store.code;
            }
        },

        computed: {
            ...mapGetters(['bookingPostcode', 'requiresStore', 'store', 'allowsInStoreBooking'])
        },

        methods: {
            ...mapActions(['setIgnoreStore', 'setStore']),

            checkStoreCode() {
                this.error = null;

                if (!this.storeCode) return;

                let storeCode = this.storeCode.replace(/\s/g, '');

                if (!storeCode) return;

                this.searching = true;
                this.setStore(storeCode)
                    .then(() => {
                        this.searching = false;

                        this.$router.push({name: 'postcodeSearch'});
                    })
                    .catch(error => {
                        this.searching = false;
                        this.error = error.response.data.messages[0];
                    });
            },

            initiateSetIgnoreStore() {
                this.setIgnoreStore().then(() => {
                    this.$router.push({name: this.nextPage});
                })
            },

            storeCodeWatcher(event) {
                if(event.key === "Enter") {
                    this.checkStoreCode();
                }
            },
        }
    }
</script>

<style scoped>

</style>